var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('div',{staticClass:"pc"},[_c('div',[_vm._v("备案信息")]),_c('div',[_vm._v("沪ICP备17018458号-1")]),_c('div',[_vm._v("华米信息技术（上海）有限公司 ")])]),_c('div',{staticClass:"h5"},[_c('div',[_vm._v("备案信息")]),_c('div',[_vm._v("沪ICP备17018458号-1")]),_c('div',[_vm._v("华米信息技术（上海）有限公司 ")])])])
}]

export { render, staticRenderFns }